import axiosInstance from "../axiosInstance";

export const orderExceptionsService = {
  options: async () => {
    const response = await axiosInstance.get("/order-exceptions", {
      suppressErrorToast: true,
    });
    return response.data;
  },
  generate: async (payload) => {
    const response = await axiosInstance.post("/order-exceptions", payload, {
      suppressErrorToast: true,
    });
    return response.data;
  },
};
